import { render, staticRenderFns } from "./HeadForm.vue?vue&type=template&id=1dd5801b&scoped=true"
import script from "./HeadForm.vue?vue&type=script&lang=js"
export * from "./HeadForm.vue?vue&type=script&lang=js"
import style0 from "./HeadForm.vue?vue&type=style&index=0&id=1dd5801b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd5801b",
  null
  
)

export default component.exports